// src/filter/registry.ts
import type { FilterKey, Option } from "@/filter";

export type SourceKind =
  | { type: "static"; data: Option[] }
  | { type: "endpoint"; url: string; map?: (raw: any) => Option[] }
  | {
      type: "loader";
      load: (ctx?: { signal?: AbortSignal; q?: string }) => Promise<Option[]>;
    };

export type FilterRegistry = Record<FilterKey, SourceKind>;

export const defaultFilterRegistry: FilterRegistry = {
  categoryArticle: {
    type: "static",
    data: [
      { value: "", label: "SEMUA" },
      { value: "SIMPUPUK", label: "SIMPUPUK" },
      { value: "SIMTANAMAN", label: "SIMTANAMAN" },
      { value: "ALSINTAN", label: "ALSINTAN" },
    ],
  },
  appType: {
    type: "static",
    data: [
      { value: "", label: "SEMUA" },
      { value: "SIPUTANI", label: "SIMPUPUK" },
      { value: "SITANAMAN", label: "SIMTANAMAN" },
      { value: "ALSINTAN", label: "ALSINTAN" },
    ],
  },
  status: {
    type: "static",
    data: [
      { label: "diajukan", value: "diajukan" },
      { label: "disetujui", value: "disetujui" },
      { label: "ditolak", value: "ditolak" },
    ],
  },
  kategoriPengajuan: {
    type: "static",
    data: [
      { label: "subsidi", value: "subsidi" },
      { label: "non subsidi", value: "non subsidi" },
    ],
  },
  jenisPerolehan: {
    type: "static",
    data: [
      { value: "", label: "SEMUA" },
      { label: "Hibah", value: "Hibah" },
      { label: "Pinjam Pakai", value: "PinjamPakai" },
    ],
  },
  jenisTanaman: {
    type: "endpoint",
    url: "configuration/letter-type?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  jenisPupuk: {
    type: "endpoint",
    url: "master/tipe-pupuk?limit=9999",
    map: (data: DataPaginate<any>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({
          label: `${d.name} - ${d.submissionCategory}`,
          value: String(d.id),
        })),
      ];
    },
  },
  kategoriAlsintan: {
    type: "endpoint",
    url: "master/alsintan-category?limit=9999",
    map: (data: DataPaginate<CategoryAlsintanResponse>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  alsinstan: {
    type: "endpoint",
    url: "master/alsintan?limit=9999",
    map: (data: DataPaginate<AlsintaResponse>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  roles: {
    type: "endpoint",
    url: "master/role?limit=9999",
    map: (data: DataPaginate<RoleResponse>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  users: {
    type: "endpoint",
    url: "master/user?limit=9999",
    map: (data: DataPaginate<RoleResponse>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  poktan: {
    type: "endpoint",
    url: "master/poktan?limit=9999",
    map: (data: DataPaginate<RoleResponse>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  metodePengiriman: {
    type: "endpoint",
    url: "master/shipping-metode?limit=9999",
    map: (data: DataPaginate<RoleResponse>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
  tanaman: {
    type: "endpoint",
    url: "master/plant?limit=9999",
    map: (data: DataPaginate<RoleResponse>) => {
      return [
        { label: "Semua", value: "" },
        ...data.items.map((d) => ({ label: d.name, value: String(d.id) })),
      ];
    },
  },
};
